import firebase from '../firebase/firebase';
import { sendPaymentDetailsToServer } from '../utils/database/database-utils';
import { types } from './types';

const db = firebase.database();

export const makePayment = ({ client: clientId, serviceId, token, providerId, companyId, servicePeriod, percentTax }) => async dispatch => {
    return new Promise(async (resolve, reject) => {
        // console.log('RUNNING MAKE-PAYMENT');
        await sendPaymentDetailsToServer(clientId, serviceId, token, providerId, companyId, servicePeriod, percentTax, (confirmationData) => {
            // console.log('PAYMENT HAS RESOLVED', confirmationData);
            resolve(confirmationData);
        });
    });
}

export const getCreditAmount = (userId) => async dispatch => {
    const creditsRef = db.ref(`/clients/${userId}/credits`);
    creditsRef.off();
    creditsRef.on('value', snap => {
        dispatch({
            type: types.GET_CREDITS_SUCCESS,
            payload: snap.val()
        })
    }, (e)=>{
        console.log('ERROR: Could not get credits', e);
        dispatch({
            type: types.GET_CREDITS_FAIL,
            payload: null
        })
    })
}

// export const getCreditRefund = (userId, cost, remainingCredits) => {
//     const newCredits = remainingCredits + cost;
//     db.ref(`/clients/${userId}/credits`).set(newCredits)
//     .catch(e => {
//         // console.log(e)
//     }); // TODO: this is likely not a very secure way of handling credits - should be done on the backend
// }

export const handleRefund = () => dispatch => {
    // NEED ORDERNUMBER/purchaseId to exists upon purchase so that this can be passed around safely rather than payment data which can be hacked
    // send pending refund data to a node in database then trigger a DB function and handle refund on backend
    // cost that will be refunded will be from a purchase ID - the purchase ID will have the purchase info ie credits used stripe payments amount used so we know who to refund and what
}


// WEBPACK FOOTER //
// ./src/js/actions/payment-actions.js